// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-box {
  display: flex;
  flex-direction: column;
  min-width: 100%;
  max-height: 450px;
}

.mat-column-tool {
  flex: 0 0 5% !important;
}

.mat-column-orderValue,
.mat-column-freightageSurcharge {
  flex: 0 0 8% !important;
}

.mat-column-creationDate,
.mat-column-id,
.mat-column-deliveryState {
  flex: 0 0 10% !important;
}`, "",{"version":3,"sources":["webpack://./projects/zbs-app/src/app/modules/order/components/order-table/order-table.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAGA;;EAEI,uBAAA;AAAJ;;AAGA;;;EAGI,wBAAA;AAAJ","sourcesContent":[".table-box {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-width: 100%;\r\n    max-height: 450px;\r\n}\r\n\r\n.mat-column-tool {\r\n    flex: 0 0 5% !important;\r\n    // width: 28% !important;\r\n}\r\n\r\n.mat-column-orderValue,\r\n.mat-column-freightageSurcharge {\r\n    flex: 0 0 8% !important;\r\n}\r\n\r\n.mat-column-creationDate,\r\n.mat-column-id,\r\n.mat-column-deliveryState {\r\n    flex: 0 0 10% !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
